<template>
  <v-container>
    <img src="@/assets/logoAmeris.jpg" height="150"/>
    <div v-if="!loading">
      <v-card>
        <v-card-title class="ma-2">
          <v-row align="center" justify="start">
            {{ tableTitle }}
            <v-spacer />
            <v-btn icon tile>
              <download-excel
                :data="tableValues"
                :fields="csvHeaders"
                worksheet="Worksheet"
                name="download.xls"
              >
                <v-icon>mdi-download</v-icon>
              </download-excel>
            </v-btn>
          </v-row>
        </v-card-title>

        <v-data-table
          :headers="tableHeaders"
          :items="tableValues"
          :sort-by="['date']"
          :sort-desc="[true]"
          :options="options"
          :footer-props="footerProps"
        ></v-data-table>
      </v-card>
    </div>
    <div v-else>
      <v-progress-circular indeterminate color="primary"></v-progress-circular>
    </div>
  </v-container>
</template>

<script>
export default {
  name: "Quotes",
  data() {
    return {
      tableTitle: null,
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        "Access-Control-Allow-Origin": "*",
      },
      tableHeaders: [
        { text: "Fecha", value: "date" },
        { text: "Serie", value: "series" },
        {
          text: "Valor cuota",
          value: "quotaValue",
          align: "right",
        },
        {
          text: "Patrimonio de la serie",
          value: "netEquity",
          align: "right",
        },
        {
          text: "Número de cuotas de la serie",
          value: "quoteNumber",
          align: "right",
        },
        {
          text: "Activos totales",
          value: "totalAssets",
          align: "right",
        },
        {
          text: "Moneda",
          value: "currency",
        },
      ],
      csvHeaders: {
        Fondo: "fund",
        Fecha: "date",
        Serie: "series",
        "Valor cuota": "quotaValue",
        "Patrimonio de la serie": "netEquity",
        "Numero de cuotas de la serie": "quoteNumber",
        "Activos totales": "totalAssets",
        Moneda: "currency",
      },
      options: {
        itemsPerPage: 50,
      },
      footerProps: {
        itemsPerPageOptions: [50, -1],
        showFirstLastPage: true,
        firstIcon: "mdi-arrow-collapse-left",
        lastIcon: "mdi-arrow-collapse-right",
        prevIcon: "mdi-minus",
        nextIcon: "mdi-plus",
      },
      tableValues: [],
      loading: false,
      values: [],
    };
  },
  methods: {
    format_float(number) {
      return number.toLocaleString("es-CL", { minimumFractionDigits: 4 });
    },
    format_int(number) {
      return number.toLocaleString("es-CL");
    },
    format_quote_numbers(bookValue, netEquity) {
      const output = Math.floor(netEquity / bookValue);
      // eslint-disable-next-line no-restricted-globals
      if (isNaN(output)) {
        return "-";
      }
      return output;
    },
    graph_query(fundId) {
      return `query {
        ameris (
          fund: ${fundId}
        ) {
          date
          series
          quotaValue
          netEquity
          totalAssets
          originalCurrency
          fund {
            name
          }
        }
      }`;
    },
    async loadQuotes(fundId) {
      this.loading = true;
      const response = await this.axios.post(
        process.env.VUE_APP_BACK,
        {
          query: this.graph_query(fundId),
        },
        this.headers,
      );
      response.data.data.ameris.forEach((res) => {
        if (!this.tableTitle) {
          this.tableTitle = res.fund.name;
        }
        this.tableValues.push({
          fund: res.fund.name,
          date: res.date,
          series: res.series,
          quotaValue: this.format_float(res.quotaValue),
          netEquity: this.format_int(res.netEquity),
          quoteNumber: this.format_int(
            this.format_quote_numbers(res.quotaValue, res.netEquity),
          ),
          totalAssets: this.format_int(res.totalAssets),
          currency: res.originalCurrency,
        });
      });
      this.loading = false;
    },
  },
  beforeMount() {
    const id = Number.parseInt(this.$route.params.id, 10);
    if (Number.isInteger(id)) {
      this.loadQuotes(id);
    }
  },
};
</script>

<style scoped>
table {
  margin-left: auto;
  margin-right: auto;
}
</style>
